<template>
  <div class="form">
    <form action="">
      <div class="form__item">
        <div class="form__item-title">是否显示数据</div>
        <div class="form__item-inputs">
          <ul>
            <li>
              <input id="displayOpts0" type="checkbox" v-model="isShowDataValues">
              <label for="displayOpts0"><span><i></i></span>数据</label>
            </li>
            <li v-show="chartType !== 'PieChart'">
              <input id="displayOpts1" type="checkbox" v-model="isShowGroupLabels">
              <label for="displayOpts1"><span><i></i></span>类别标题</label>
            </li>
          </ul>
        </div>
      </div>
      <div class="form__item">
        <div class="form__item-title">系列标题位置</div>
        <div class="form__item-inputs form__item-inputs--less">
          <ul>
            <li>
              <input id="bottom" type="radio" v-model="legendPosition" value="1" name="legendPosition">
              <label for="bottom"><span><i></i></span>下边</label>
            </li>
            <li>
              <input id="right" type="radio" v-model="legendPosition" value="0" name="legendPosition">
              <label for="right"><span><i></i></span>右边</label>
            </li>
          </ul>
        </div>
      </div>
      <div class="form__submit">
        <div class="form__submit-btn button--primary" @click="onSubmit()">提交</div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      chartType: '',
      id: '',
      scenesId: '',
      option: '',
      displayOpts: [
        {checked: true, label: '数据', textType: 'label'},
        {checked: true, label: '类别标题', textType: 'category'}
      ],
      legendPosition: 0,
      isShowDataValues: true,
      isShowGroupLabels: true
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg'
    ])
  },
  created() {
    if (this.TOOL.selectedSprite[0].type === 'Chart') {
      this.getChartData();
    }
  },
  watch: {
    'SelectSprites_Msg'(val, oldVal) {
      val && val[0] && this.getChartData();
    }
  },
  mounted() {
    this.$bus.on('changeChartType', (type) => {
      this.chartType = type;
    });
  },
  methods: {
    getChartData() {
      this.id = this.TOOL.selectedSprite[0].id;
      this.scenesId = this.TOOL.selectedSprite[0].scenesId;
      this.option = this.TOOL.selectedSprite[0].option;
      this.chartType = this.option.chartType;
      this.isShowDataValues = (this.option.data || {}).isShowDataValues;
      this.isShowGroupLabels = (this.option.data || {}).isShowGroupLabels;
      this.legendPosition = (this.option.data || {}).legendPosition;
    },
    onSubmit () {
      this.option.data.isShowDataValues = this.isShowDataValues;
      this.option.data.isShowGroupLabels = this.isShowGroupLabels;
      this.option.data.legendPosition = Number(this.legendPosition);
      this.option.chartOption = Object.assign({}, this.$chartFromJson(this.option));
      this.TOOL.updateSprite(this.id, this.option, this.scenesId);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/colors.scss";

.form {
  width: 246px;
  height: 218px;
  background-color: $c1;
  padding-top: 16px;
  padding-left: 10px;
  padding-right: 10px;

  input[type="checkbox"], input[type="radio"] {
    // appearance: none;
    -webkit-appearance: none;
    outline: none;
    display: none;
  }
  input[type="checkbox"]+label span, input[type="radio"]+label span{
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    margin-right: 5px;
    border: 1px solid #9692a9;
    border-radius: 50%;
    i {
      display: none;
    }
  }
  label {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  input[type="checkbox"]:checked+label span, input[type="radio"]:checked+label span {
    i {
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #9692a9;
    }
  }


  &__item-title {
    margin-bottom: 13px;
    text-align-last: left;
  }
  &__item-inputs {
    >ul {
      display: flex;
      align-items: center;
      margin-bottom: 28px;

      >li {
        display: flex;
        align-items: center;
        margin-right: 13px;
        >input {
          margin-right: 0.5em;
        }
      }
    }

    &--less {
      >ul {
        >li {
          margin-right: 13px;
        }
      }
    }
  }
  &__submit {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__submit-btn {
    width: 90px;
    line-height: 30px;
    // background-color: $c2;
    color: white;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/content/chartTextOptions.vue